import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { Shape2, Shape2Icon } from '../Shape2/Shape2';
import { TextInputDecorator } from '../TextInputDecorator/TextInputDecorator';

import './OutdoorSearchInput.css';

export interface OutdoorSearchInputProps {
    placeholder: string;
    cls?: string;
    onChange: (value: string) => void;
}

interface OutdoorSearchInputState {
    text?: string;
}

export class OutdoorSearchInput extends React.Component<
    OutdoorSearchInputProps,
    OutdoorSearchInputState
> {
    private block = 'OutdoorSearchInput';

    constructor(props: OutdoorSearchInputProps) {
        super(props);

        this.state = {
            text: ''
        };
    }

    render() {
        return (
            <div
                className={`${this.props.cls && this.props.cls} ${Bem.cls(
                    this.block
                )}`}
            >
                <TextInputDecorator
                    theme="normal"
                    size="n"
                    pin="round-round"
                    cls={Bem.cls(this.block, 'input')}
                    placeholder={this.props.placeholder}
                    hasClear={true}
                    onChange={(value: string) => {
                        this.props.onChange(value);
                        this.setState({ text: value });
                    }}
                    text={this.state.text}
                    iconLeft={
                        <Shape2
                            width={20}
                            height={20}
                            icon={Shape2Icon.mapPin}
                        />
                    }
                />
            </div>
        );
    }
}
